import DataProtection from "../../data/DataProtection";
import { CardContainer } from "../../components/UserInterface/CardContainer";

const ProtectionList = () => {
  return (
    <div className="protection-list-wrapper" data-cy="protection-list-cy">
      {DataProtection &&
        DataProtection.map((data, idx) => {
          return (
            <div className="protection-item-section" key={`pis-${idx}`}>
              <div className="protection-item-section-title">
                {data && data.title}
              </div>
              <div className="protection-item-section-list">
                {data.insurances &&
                  data.insurances.map((item, idx) => {
                    return (
                      <div
                        className="protection-item-wrapper"
                        key={`piscc-${idx}`}
                      >
                        <CardContainer
                          title={item.name}
                          titleFontFamily="Campton-bold"
                          titleFontSize="24px"
                          titleFontSizeMobile="16px"
                          href={item.slug}
                          slug={item.slug}
                          button="Baca"
                          subtitle={item.desc}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}

      <style jsx>{`
        .protection-list-wrapper {
          padding: 0 16px;
        }
        .protection-item-section {
          max-width: 940px;
          margin-left: auto;
          margin-right: auto;
          padding: 60px 0;
        }
        .protection-item-section:not(:last-child) {
          border-bottom: 1px solid #7f7f7f;
        }
        .protection-item-section-title {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 32px;
        }
        .protection-item-section-list {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }
        .protection-item-wrapper:not(:only-child) {
          margin: 0 24px 24px 0px;
        }
        @media only screen and (max-width: 780px) {
          .protection-item-section {
            padding: 36px 0 32px;
          }
          .protection-item-section-title {
            font-size: 16px;
          }
          .protection-item-wrapper:not(:only-child) {
            margin-right: 0;
          }
          .protection-item-wrapper:not(:last-child) {
            margin-bottom: 24px;
          }
        }
      `}</style>
    </div>
  );
};

export default ProtectionList;
